import React from 'react';
import '../../styles/chat.scss'

const ChatComponent = () => {
    return (
        <div className='chat_wrap'>
            <img src="/img/Chat.svg" alt="chat" />
        </div>
    );
};

export default ChatComponent;